import React from "react"
import "../styles/sending.scss"

const Sending: React.FC = () => {
  return <div className="lds-dual-ring"></div>
}

export default Sending
